<template>
  <div class="account-page addresses">
    <AccountPanel title="Lista adresów dostaw">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">imię i nazwisko</th>
            <th scope="col">ulica</th>
            <th scope="col">kod pocztowy</th>
            <th scope="col">miasto</th>
            <th scope="col">e-mail</th>
            <th scope="col">telefon</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="address in user.addresses">
            <td>{{address.forname}} {{address.surname}}</td>
            <td>{{address.street}}</td>
            <td>{{address.postcode}}</td>
            <td>{{address.city}}</td>
            <td>{{address.email}}</td>
            <td>{{address.phone}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </AccountPanel>
  </div>
</template>

<script>

  import { mapState } from 'vuex';

  import AccountPanel from './AccountPanel.vue'


  export default {
    components: {AccountPanel},
    computed: {
      ...mapState({
        user: state => state.user
      }),
    },

    beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }
      this.$store.dispatch('user/getAddresses');


    }

  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/Addresses.vue